import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const AREAS = [
  'Sleaford', 'Ruskington', 'Heckington', 'Metheringham',
  'Billinghay', 'Cranwell', 'Anwick', 'North Kyme',
  'Rauceby', 'Digby', 'Scopwick', 'Ancaster',
  'Wellingore', 'Navenby', 'Bracebridge Heath', 'Leasingham',
];

export default function ServiceAreas() {
  const { ref: leftRef, isVisible: leftVisible } = useScrollAnimation();
  const { ref: rightRef, isVisible: rightVisible } = useScrollAnimation();

  return (
    <section className="bg-[#071120] py-0 relative">
      <div className="flex flex-col lg:flex-row min-h-[600px]">
        {/* Left: Content */}
        <div
          ref={leftRef as React.RefObject<HTMLDivElement>}
          className={`flex-shrink-0 lg:w-2/5 bg-[#0D1E35] px-8 md:px-12 py-16 flex flex-col justify-center transition-all duration-1000 ${
            leftVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'
          }`}
        >
          <p className="text-[#C8A96A] text-xs tracking-widest uppercase font-medium mb-3">Coverage</p>
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-white mb-4">
            Serving Sleaford &amp;{' '}
            <span className="bg-gradient-to-r from-[#C8A96A] to-[#E0C78A] bg-clip-text text-transparent">
              Surrounding Areas
            </span>
          </h2>
          <p className="text-white/60 text-sm leading-relaxed mb-8">
            Based in Sleaford, Lincolnshire, we cover the town and all nearby villages. 
            Not sure if we cover your area? Just give us a call.
          </p>

          {/* Area tags */}
          <div className="flex flex-wrap gap-2 mb-8">
            {AREAS.map((area) => (
              <span
                key={area}
                className="border border-[#C8A96A]/30 text-[#E0C78A] text-xs px-3 py-1.5 rounded-full hover:bg-[#C8A96A]/10 hover:border-[#C8A96A]/60 transition-all duration-200 cursor-default"
              >
                {area}
              </span>
            ))}
          </div>

          {/* Emergency call */}
          <div
            className="flex items-center gap-4 border border-[#C8A96A]/20 rounded-xl p-4"
            style={{ background: 'linear-gradient(135deg, rgba(200,169,106,0.08), rgba(168,137,79,0.04))' }}
          >
            <div className="w-12 h-12 flex items-center justify-center bg-[#C8A96A]/20 rounded-xl flex-shrink-0">
              <i className="ri-flashlight-fill text-[#C8A96A] text-xl" />
            </div>
            <div>
              <p className="text-white font-semibold text-sm">Emergency Electrical Services</p>
              <a
                href="tel:01529265060"
                className="text-[#C8A96A] text-sm font-bold hover:text-[#E0C78A] transition-colors cursor-pointer"
              >
                01529 265060
              </a>
            </div>
          </div>
        </div>

        {/* Right: Map */}
        <div
          ref={rightRef as React.RefObject<HTMLDivElement>}
          className={`flex-1 min-h-[400px] lg:min-h-0 transition-all duration-1000 delay-200 ${
            rightVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'
          }`}
        >
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d76986.24!2d-0.4256!3d53.0044!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4879b2e18e1c2c1b%3A0x53f4b3b9a9ed7e96!2sSleaford%2C%20Lincolnshire%2C%20NG34!5e0!3m2!1sen!2suk!4v1700000000000!5m2!1sen!2suk"
            title="Quantum Electrical Services - Sleaford Lincolnshire service area map"
            className="w-full h-full min-h-96"
            loading="lazy"
            style={{ border: 0, filter: 'grayscale(30%) contrast(1.05)' }}
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
}
